module.exports = __webpack_public_path__ + "static/media/image_case_luye.2abf1c42.png";